import React, { useState } from "react";
import { Form, Input, Button, message, Card, Typography } from "antd";
import { authAxios, getEmailFromSessionStorage } from "../utils/session_utils";

const { Item } = Form;
const { Paragraph } = Typography;

const VideoTranscript: React.FC = () => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (values: { videoUrl: string }) => {
		setLoading(true);
		try {
			// Use authAxios instead of fetch
			const data = JSON.stringify({
				video_url: values.videoUrl,
				email: getEmailFromSessionStorage() || "",
			});
			const config = {
				method: "POST",
				url: `${process.env.REACT_APP_BACK_END_API}/video-transcript`,
				data: data,
				headers: {
					"Content-Type": "application/json",
				},
			};

			const response = await authAxios(config);

			if (response.data.success) {
				message.success("Transcript job submitted! The transcript will be emailed to you.");
				form.resetFields();
			} else {
				message.error("API did not return a successful response.");
			}
		} catch (error) {
			message.error("Failed to submit video URL. Please try again.");
		} finally {
			setLoading(false);
		}
	};

	const validateS3Url = (_: any, value: string) => {
		if (!value || value.startsWith("s3://")) {
			return Promise.resolve();
		}
		return Promise.reject(new Error("Please enter a valid S3 URL starting with 's3://'"));
	};

	return (
		<Card title="Video Transcriber" style={{ maxWidth: 500, margin: "50px auto" }}>
			<Form form={form} layout="vertical" onFinish={handleSubmit} initialValues={{ videoUrl: "" }}>
				<Item
					label="S3 Video URL"
					name="videoUrl"
					rules={[
						{ required: true, message: "Please enter the S3 video URL." },
						{ type: 'url', message: 'Please enter valid url' },
					]}
				>
					<Input placeholder="Enter S3 Video URL" />
				</Item>

				<Button type="primary" htmlType="submit" loading={loading} block>
					{loading ? "Submitting..." : "Submit"}
				</Button>
			</Form>
			<Paragraph type="secondary" style={{ marginTop: 20, fontSize: 12 }}>
				<strong>Note:</strong> Won’t work with private or access restricted videos, or YouTube URLs.
			</Paragraph>
		</Card>
	);
};

export default VideoTranscript;
